import http from '../../http';
import { SERVER_URL } from '../../config';

export const getSinglePurchaseData = (params) => http.get(`${SERVER_URL}/api-main/v1/purchase`, {params: {...params}});